<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="500"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <v-card>
      <v-card-title>Adicionando transportador</v-card-title>
      <v-card-text class="text--primary">
        <v-row>
          <v-col cols="12">
            <px-autocomplete-transportador v-model="transportador"
                                        class="required"
                                        :error="$v.transportador.$error"
                                        @blur="$v.transportador.$touch()"
                                        required/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary"
               :loading="loading"
               :disabled="$v.$invalid"
               @click="save">
          Enviar
        </v-btn>
        <v-btn @click="close">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import CotacaoService from './cotacao-frete-service';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      menuOpened: false,
      loading: false,
      transportador: null,
    };
  },
  methods: {
    close() {
      this.menuOpened = false;
    },
    save() {
      this.loading = true;
      CotacaoService.addTransportador(this.cotacao.id, this.transportador.id)
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Transportador adicionado', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildInitialState() {
      this.transportador = null;
      this.$v.$reset();
    },
  },
  watch: {
    menuOpened() {
      if (!this.menuOpened) {
        return;
      }
      this.buildInitialState();
    },
  },
  validations: {
    transportador: {
      required,
    },
  },
};
</script>
